import React from 'react';
import { motion } from 'framer-motion';
import SwotQuadrant from './SwotQuadrant';

const SwotMatrix = () => {
  const quadrants = [
    {
      title: 'Strengths',
      category: 'strengths',
      color: 'green',
      description: 'Internal positive factors'
    },
    {
      title: 'Weaknesses',
      category: 'weaknesses',
      color: 'red',
      description: 'Internal negative factors'
    },
    {
      title: 'Opportunities',
      category: 'opportunities',
      color: 'blue',
      description: 'External positive factors'
    },
    {
      title: 'Threats',
      category: 'threats',
      color: 'orange',
      description: 'External negative factors'
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 0.3 }}
      className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-6xl mx-auto"
    >
      {quadrants.map((quadrant, index) => (
        <motion.div
          key={quadrant.category}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
        >
          <SwotQuadrant {...quadrant} />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default SwotMatrix;